import react, { useEffect} from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import mainImage from "../../assets/img/goose.jpg"
import mainImage1 from "../../assets/img/goose1.jpg"
import mainImage2 from "../../assets/img/goose2.jpg"
import DogDetails from "../dogDetails/dogDetails";
import Pedigree from "../pedigree/pedigree";
import { goose_details } from "../../data/dogs/goose_detail";
import { goose_lineage } from "../../data/dogs/goose_lineage";


function DogGoose
() {
  let location = useLocation()
  useEffect(() => {
    
    if (location.pathname.includes("dogs")) {
      document.title = "Goose - High Altitude Labs"

      let e = document.getElementById('canonicallink')
      if(e != null) {
        document.head.removeChild(e)
      }

      let link:HTMLLinkElement = document.createElement('link')

      link.id = "canonicallink"
      link.rel = 'canonical';
      link.href = 'https://highaltitudelabs.com/dogs/boys/goose/';
      link.setAttribute("data-react-helmet","true")
      document.head.appendChild(link);


    }
  },[])
  return (
    <div>
      
      <header></header>
      <section>
        <div className="container">

          <div>
            
            <div className="section">
              <div className="row card">
                <div className="col s12 m6">
                <h5>High Altitude's Wingman</h5>
                  <div className="card-image z-depth-2">
                    <img  src={mainImage}  />
                  </div>
                </div>

                <div className="col s12 m6">
                  <div className="container">
              <DogDetails name='"Goose"' content={(<div></div>)} detailItems={goose_details}/>

                  </div>
                </div>

              </div>
              <div className="row card">
                <div className="col s12 m12">
                  <h5>Pedigree</h5>
                  <Pedigree self="High Altitude's Wingman" lineage={goose_lineage}/>
                </div>
              </div>

            </div>
          </div></div>

      </section>
    </div>
  );
}

export default DogGoose
